import { render } from "./FinalPractice.vue?vue&type=template&id=ba582376"
import script from "./FinalPractice.vue?vue&type=script&lang=js"
export * from "./FinalPractice.vue?vue&type=script&lang=js"

import "./FinalPractice.vue?vue&type=style&index=0&id=ba582376&lang=scss"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__